export function resolveContentType(file: File): string {
  if (file.type) return file.type;

  const ext = file.name.split('.').pop()?.toLowerCase();
  const mimeMap: Record<string, string> = {
    sta: 'text/plain',
    mt940: 'text/plain',
    csv: 'text/csv',
    txt: 'text/plain',
    pdf: 'application/pdf',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  };

  return mimeMap[ext ?? ''] ?? 'application/octet-stream';
}
